import React from 'react';
import ReactDOM from 'react-dom/client';
import 'shared-branding/vfootball-design-system.css';
import { preloadGlobalCritical } from './utils/imagePreload';
import { initWebViewBridge, setNativeChrome } from './utils/webviewBridge';
import { getOrCreateGuestId, writeOnboardingComplete } from './utils/guestSession';
import App from './App';

preloadGlobalCritical();
initWebViewBridge({ guest_id: getOrCreateGuestId() });

// Clear any leftover onboarding chrome flags from older builds
try {
  document.body.classList.remove('lf-onboarding', 'lf-hide-bottom-nav', 'lf-bare-chrome');
  setNativeChrome({ hideBottomNav: false, hideChrome: false, screen: null });
  // Onboarding temporarily disabled — mark complete so old redirects/storage stay quiet
  writeOnboardingComplete();
} catch {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
